import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';

import extraimg1 from '../../assets/frames/polar-extraimg1@2x-min.png';
import extraimg2 from '../../assets/frames/polar-extraimg2@2x-min.png';
import extraimg3 from '../../assets/frames/polar-extraimg3@2x-min.png';
import caseimg from '../../assets/frames/polar-caseimg@2x-min.png';
import hero from '../../assets/hero/polar-hero.jpg';
import env1 from '../../assets/envImages/polar-env1.jpg';
import env2 from '../../assets/envImages/polar-env2.jpg';
import footerBanner from '../../assets/envImages/polar-footerBanner.jpg';
import extraimg4 from '../../assets/envImages/polar-designTemplate-min.jpg';

export default {
  path: '/cases/polar',
  color: variables.polar,
  quoteData: {
    quote: 'We immediately loved their approach to us as a startup, where it felt like We App was part of our in-house team, as they always gave us feedback on how to develop our business and idea. We\'re really happy with We App as our tech partner and look forward to them developing generation 2 of our service.',
    name: 'Julia Larsson',
    profession: 'Co-Founder & CEO, Scandinavian Fintech Innovations AB',
  },
  hero: { fall: hero },
  case: { fall: caseimg },
  xtra: [
    { fall: extraimg1 },
    { fall: extraimg2 },
    { fall: extraimg3 },
  ],
  environments: { env1, env2 },
  footerBanner: { fall: footerBanner },
  extraimg4: { fall: extraimg4 },
  title: 'Polar',
  sideHeadingFirst: 'iOS & Android application',
  sideHeadingSecond: 'Developed in Swift and Android',
  infoTitle: 'What we built',
  infoBody:
  <span>
To contain the powerful blockchain technology enabling smooth transactions, Polar wanted to create a MVP, which needed an equally smooth user experience.
    <br />
    <br />
We App partnered up with Polar and created user applications for both iOS and Android. The work involved the full cycle of creating
    {' '}
    <Highlight>design templates</Highlight>
,
    {' '}
    <Highlight>frontend user experience</Highlight>
,
    {' '}
    <Highlight>backend integration</Highlight>
    {' '}
    to Open banking system protocols, and building of a
    {' '}
    <Highlight>database</Highlight>
.
    <br />
    <br />
Tech stack used:
    {' '}
    <Highlight>React Native, Nodejs, Firebase, mongoDB, REST</Highlight>
.

  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
  titleBodyData: {
    0: {
      title: 'Free international transactions in real-time',
      body:
  <span>
Polar is a Gothenburg-based started up, born and grown through the participation in two of Sweden’s most prestigious startup incubators.
    <br />
    <br />
Polar is developing a service that will enable real-time international transactions, without fees. Leveraging powerful block-chain technology based on the lightning network, to make transactions safe and instant.
    <br />
    <br />
Aiming to transform the fintech industry.
  </span>,
    },
    1: {
      title: 'From concept to reality',
      body:
  <span>
With the help of We App, Polar successfully launched their MVP, and integrated the service to two of Sweden’s biggest banks. The collaboration between Polar and We App has been so successful that We App now have the proud responsibility to develop generation 2 of their service.
  </span>,
    },
  },
};
